import "./prasora-cell.scss";
import pf from "../pf.js";
import m from "mithril";
import cb from "../checkbox/cb";
import datepicker from "../datepicker/datepicker";
import sb from "../selectbox/sb";
import fu from "../FileManager/oldfu";
import loader from "../loader";
import svg from "../svg";
import workermanager from "../worker-manager";
import myTools from "../tools/tools";
import camera from "../../camera/camera";
import msg from "../../../common/msg";
import locationcomponent from "../../app/components/LocationComponent/location-component.js";
import reportlinkcomponent from "../../app/components/ReportLinkComponent/report-link-component.js";
import appCellManager from "../../app-custom-cell-format/index.js";

import filesorter from "../file-sorter/file-sorter";

export default () => {
	let initiated = false;
	let tact = null;
	let localValue = null;
	let localText = null;
	let LocalUpdateField = null;
	let updating = false;
	let links = null;
	let nf = undefined;
	let nfd = undefined;
	let h = null;
	let reportlink = undefined;

	let customformat = undefined;
	let customclass = undefined;
	let customwidth = undefined;
	let hover = undefined;
	let morecontent = undefined;

	let tempText = null;
	let errorstate = false;
	let updaterequestsent = false;

	function Validate(nv) {
		if (nv) {
			return true;
		} else {
			return nfd.nullable;
		}
	}

	function UpdateFieldOnBackend(nv, links) {
		// console.log("requesting field update", {nf, value: nv});
		UpdateFieldOnBackendDebounce(nv, links);
	}

	let debounceTimer = undefined;
	const UpdateFieldOnBackendDebounce = (nv, links) => {
		if (Array.isArray(nv)) localValue = nv.join(",");

		if (debounceTimer) clearTimeout(debounceTimer);
		debounceTimer = setTimeout(() => {
			// console.log("updating field update", {nv, links});
			// console.log({nv, links});

			if (LocalUpdateField) LocalUpdateField(false, nf, undefined, nv, links);

			//localValue
			//  console.log("request for update", nv);
			updating = true;

			m.redraw();
		}, 800);
	};

	function UpdateOriginalFileData(nf, links) {
		if (LocalUpdateField) LocalUpdateField(true, nf, undefined, undefined, links);
	}

	function RenderCellContent(editable, v, juniors) {
		// console.log({attrs: v.attrs, localValue});
		if (nfd.islocation == "yes") {
			return m(locationcomponent, {
				editable,
				locationtype: nfd.locationtype,
				value: tempText,
				OnUpdate: (val) => {
					tempText = val;
					UpdateFieldOnBackend(tempText);
				},
			});
		} else if (reportlink) {
			return m(reportlinkcomponent, {
				reportlink,
				editable: editable && nf,
				localText,
				localValue,
				links,
				nf,
				nfd,
				tact,
				LocalUpdateField,
			});
		} else if (nfd.isImage) {
			if (editable && nf) {
				return [
					m(".existing-files-for-editing", [
						links
							? links.map((link, index) => {
									if (link) {
										return m(
											".ImageLink.DisplayThumbnail.DisplayImage",
											{
												href: link.url,
												onerror: "this.style.display = 'none'",
											},
											[
												m("img", {
													width: 50,
													height: 50,
													src: link.url,
												}),
												m(
													"a.delete-image-icon",
													{
														onclick: (e) => {
															let newArray = (localValue + "").split(",").map((a) => a.trim());
															// console.log("before", localValue, newArray);
															newArray = newArray.filter((a) => a != newArray[index]);
															// console.log("after", localValue, newArray);
															UpdateFieldOnBackend(newArray, links.splice(index, 1));
														},
													},
													[
														m(svg, {
															name: "delete",
														}),
													]
												),
											]
										);
									}
							  })
							: null,
					]),
					[
						nfd.fileoptions && nfd.fileoptions.camera
							? m(camera, {
									nf,
									links,
									options: nfd.fileoptions,
									value: v.attrs.value,
									filetypes: nfd.extAllowed,
									onchange: (newVal) => {
										console.log("file", {newVal});
										links = newVal;
										UpdateOriginalFileData(nf, links);
										m.redraw();
									},
							  })
							: m(fu, {
									nf,
									links,
									value: v.attrs.value,
									filetypes: nfd.extAllowed,
									onchange: (newVal) => {
										// console.log("file", {newVal});
										links = newVal;
										UpdateOriginalFileData(nf, links);
										m.redraw();
										// console.log("after", localValue, newArray);
										// UpdateFieldOnBackend(newArray, true);

										// UpdateFieldOnBackend(newVal);
									},
							  }),

						// links.length > 1 &&
						// 	m(filesorter, {
						// 		links,
						// 		// onupdate: (newlinks) => {
						// 		// 	UpdateFieldOnBackend(newlinks, newlinks);
						// 		// },
						// 	}),
					],
				];
			} else {
				return m(".existing-files-for-display", [
					links
						? links.map((link, index) => {
								if (link) {
									return m(
										"a.ImageLink.DisplayThumbnail.DisplayImage",
										{
											href: link.url,
											onerror: "this.style.display = 'none'",
											"data-toggle": "lightbox",
											"data-gallery": nf,
											"data-title": "prasora",
											"data-type": "image",
										},
										[
											m("img", {
												width: 50,
												height: 50,
												src: link.url,
											}),
										]
									);
								}
						  })
						: localValue.split(",").map((file, index) => {
								if (file) {
									return m(
										"a.ImageLink.DisplayThumbnail.DisplayImage",
										{
											href: file,
											onerror: "this.style.display = 'none'",
											"data-toggle": "lightbox",
											"data-gallery": nf,
											"data-title": "prasora",
											"data-type": "image",
										},
										[
											index == 0
												? m("img", {
														width: 50,
														height: 50,
														src: file,
												  })
												: null,
										]
									);
								}
						  }),
				]);
			}
		} else if (nfd.isFile) {
			if (editable && nf) {
				return [
					m(".existing-files-for-editing", [
						links
							? links.map((link, index) => {
									if (link) {
										return m(".file-item", [
											m("span.table-file-link", {}, link.caption || h.caption),
											m(
												"a.delete-file-icon",
												{
													onclick: (e) => {
														let newArray = (localValue + "").split(",").map((a) => a.trim());
														// console.log("before", localValue, newArray);
														newArray = newArray.filter((a) => a != newArray[index]);
														// console.log("after", localValue, newArray);
														UpdateFieldOnBackend(newArray, links.splice(index, 1));
													},
												},
												[
													m(svg, {
														name: "delete",
													}),
												]
											),
										]);
									}
							  })
							: null,
					]),
					nfd.fileoptions && nfd.fileoptions.camera
						? m(camera, {
								nf,
								links,
								options: nfd.fileoptions,
								value: v.attrs.value,
								filetypes: nfd.extAllowed,
								onchange: (newVal) => {
									console.log("file", {newVal});
									links = newVal;
									UpdateOriginalFileData(nf, links);
									m.redraw();
								},
						  })
						: m(fu, {
								nf,
								links,
								value: v.attrs.value,
								filetypes: nfd.extAllowed,
								onchange: (newVal) => {
									console.log({newVal});
									links = newVal;
									UpdateOriginalFileData(nf, links);
									m.redraw();
									// UpdateFieldOnBackend(newVal);
								},
						  }),
					// links.length > 1 &&
					// 	m(filesorter, {
					// 		links,
					// 		// onupdate: (newlinks) => {
					// 		// 	UpdateFieldOnBackend(newlinks, newlinks);
					// 		// },
					// 	}),
				];
			} else {
				return [
					links
						? m(
								".existing-files-for-display",
								links.map((link, index) => {
									if (link) {
										return m(
											"a.table-file-link..file-item",
											{
												// target: "_blank",
												href: link.url, //|| file,
											},
											link.caption || h.caption
										);
									}
								})
						  )
						: null,
				];
			}
		} else if (nfd.isBool) {
			if (editable && nf) {
				return [
					m(cb, {
						value: localValue,
						disabled: false,
						onchange: (e) => {
							localValue = e.target.checked;
							UpdateFieldOnBackend(e.target.checked);
						},
					}),
				];
			} else {
				return [
					m(cb, {
						value: localValue,
						disabled: true,
					}),
				];
			}
		} else if (nfd.isDate) {
			if (editable && nf) {
				{
					return [
						m(datepicker, {
							options: {
								minDate: nfd.mindate,
								maxDate: nfd.maxdate,
								size: 1,
								showtime: nfd.isTime,
								value: localValue,
								OnUpdateEvent: (e) => {
									localValue = e;
									UpdateFieldOnBackend(e);
								},
							},
						}),
					];
				}
			}
		} else if (nfd.isSelect) {
			if (editable && nf) {
				return [
					m(sb, {
						tact: tact,
						value: localValue,
						text: localText,
						nf: nf,
						multiple: nfd.isMultiSelect,
						onchange: (vals, texts) => {
							// console.log({ e });
							localValue = vals;
							localText = texts;
							UpdateFieldOnBackend(vals);
						},
					}),
				];
			}
		} else if (nfd.isTextArea) {
			if (editable && nf) {
				return [
					m("textarea.editable-td", {
						value: tempText,
						rows: Math.min(4, (localText.match(/\r?\n/g) || "").length + 1),
						size: 1,
						oninput: (e) => {
							tempText = e.target.value;
							UpdateFieldOnBackend(tempText);
						},
						// onchange: (e) => {
						// 	tempText = e.target.value;
						// },
						// onkeydown: (e) => {
						// 	if (e.keyCode == 9) {
						// 		UpdateFieldOnBackend(tempText);
						// 	}
						// 	if (e.keyCode == 27) {
						// 		tempText = localText;
						// 	}
						// },
						// onfocusout: (e) => {

						// },
						// onblur: () => {
						//     UpdateFieldOnBackend(tempText);
						// }
					}),
				];
			} else {
				if (links) {
					return links.map((link, index) => {
						if (link) {
							return m(
								"a.table-file-link",
								{
									// target: "_blank",
									href: link.url, //|| file,
								},
								nfd.isDate ? tempText : link.caption || h.caption
							);
						}
					});
				} else {
					return pf.ConvertToCommaSeparaterNumber(tempText, customclass);
				}
			}
		}

		if (editable && nf) {
			return [
				m("input.editable-td", {
					value: tempText,
					size: 1,
					oninput: (e) => {
						// console.log("changing");
						tempText = e.target.value;
						// console.log({tempText});
						UpdateFieldOnBackend(tempText);
					},
				}),
			];
		} else {
			if (v.attrs.links) {
				return m(".all-link-wrapper", [
					v.attrs.links.map((file, index) => {
						if (file) {
							// console.log(file);
							return m(
								"a.simple-file-link",
								{
									// target: "_blank",
									href: file.url,
								},
								m("span", file.caption)
							);
						}
					}),
				]);
			} else {
				return pf.ConvertToCommaSeparaterNumber(tempText, customclass);
			}
		}

		// }
	}

	return {
		view: (v) => {
			if (!initiated) {
				tact = v.attrs.tact;
				reportlink = v.attrs.reportlink;
				localValue = v.attrs.value;
				localText = v.attrs.text;
				tempText = localText;
				LocalUpdateField = v.attrs.UpdateField;
				links = v.attrs.links;
				initiated = true;

				h = v.attrs.col;
				nf = v.attrs.nf;
				nfd = v.attrs.nfd || {};

				customclass = v.attrs.customclass;
				customwidth = v.attrs.customwidth;
				customformat = v.attrs.customformat;
				// if (customformat) console.log("cell", {customformat});

				if (v.attrs.hover) hover = v.attrs.hover;

				if (v.attrs.morecontent) morecontent = v.attrs.morecontent;
			}

			// console.log({tempText});

			let editable = v.attrs.editable;

			if (nfd.isDate) {
				if (!nfd.isTime && links && links.length == 1) {
					links[0].caption = localText;
				}
			}

			// console.log({headercontent: v.attrs.headercontent});

			if (editable && !customformat) return RenderCellContent(editable, v);
			else
				return m(
					v.attrs.stripdata ? ".td.datacells" : "td.datacells",
					{
						style: customwidth ? `width:${customwidth}px;` : null,
						title: editable ? null : hover,
						tabindex: -1,
						"more-details": editable ? null : morecontent,
						//   onkeydown: e => {
						//     if (e.key == "Delete")
						//       if (h != null) {
						//         if (nfd.isDate && editable && nf && nfd.nullable) {
						//           console.log("delete date");
						//         }
						//       }
						//   },
						class: (() => {
							// if (updating) return "updating-value";
							// else
							return `${editable && nf ? "prasora-editable-content editable" : "prasota-td-content non-editable"}
						${updating ? "updating-value" : ""}	 
                        ${customclass ? customclass : ""}
                        ${hover ? "td-has-hover" : ""}
                        ${morecontent ? "td-has-more-content" : ""}
                        ${nfd.isImage ? "colImage" : ""}
                        ${nfd.isFile ? "colFile" : ""}
                        ${nfd.isBool ? "colBool" : ""}
                        ${nfd.isNumber ? "colNumber" : ""}
                        ${nfd.isSelect ? "colSelect" : ""}
                        ${nfd.isMultiSelect ? "colMultiSelect" : ""}
                        ${nfd.isTextArea ? "colTextArea" : ""}
						${v.attrs.juniors ? "cell-non-editor" : "cell-editor"}
                        ${localValue ? "has-values " : "empty-cell "}
                        `
								.replace(/\n/g, " ")
								.replace(/\s+/g, " ");
						})(),
					},
					customformat
						? m(appCellManager, {
								editable: editable && nf,
								customformat,
								text: localText,
								onUpdate: (newtext) => {
									tempText = newtext;
									UpdateFieldOnBackend(newtext);
								},
						  })
						: [
								m(".cell-col-title", {class: `col__${pf.RemoveSpecialCharacters(h.name)}`}, h.caption),
								m(
									".cell-value",
									{
										style: customwidth ? `width:${customwidth}px;` : "",
									},
									[
										m(
											".rendered-content",
											{
												style: v.attrs.juniors ? "visibility:hidden;" : "",
											},
											RenderCellContent(editable, v)
										),
										v.attrs.juniors,
									]
								),
						  ]
				);
		},
	};
};
